import { render, staticRenderFns } from "./ReporteCurvaDesgasteVehiculo.vue?vue&type=template&id=4236f6f8&scoped=true"
import script from "./ReporteCurvaDesgasteVehiculo.vue?vue&type=script&lang=js"
export * from "./ReporteCurvaDesgasteVehiculo.vue?vue&type=script&lang=js"
import style0 from "./ReporteCurvaDesgasteVehiculo.vue?vue&type=style&index=0&id=4236f6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4236f6f8",
  null
  
)

export default component.exports